import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Tooltip as UnstyledTooltip, TooltipRefProps } from 'react-tooltip';

// Create root level element for react-tooltips
let tooltipPortalNode: HTMLDivElement;
if (typeof document !== 'undefined') {
  tooltipPortalNode = document.createElement('div');
  tooltipPortalNode.id = 'tooltip-portal';
  document.body.appendChild(tooltipPortalNode);
}

// Wrapper component to portal react-tooltips
function TooltipPortal({ children }: { children: React.ReactNode }) {
  if (typeof document === 'undefined') {
    return null; // SSR guard
  }

  return ReactDOM.createPortal(children, tooltipPortalNode);
}

export const SmallTooltip = styled(UnstyledTooltip)`
  --rt-opacity: 1 !important;
  font-style: normal;
  font-weight: 400;
  font-size: 13px !important;
  line-height: 16px;
  font-feature-settings: 'tnum' on, 'lnum' on;
  border: 1px solid ${({ theme }) => theme.colors.divider} !important;
  border-radius: 4px !important;
  background-color: ${({ theme }) => theme.colors.bgPage} !important;
  backdrop-filter: saturate(150%) blur(150px) !important;
  z-index: 3 !important;
  cursor: pointer !important;
`;

const StyledPortalTooltip = styled(UnstyledTooltip)`
  --rt-opacity: 1 !important;
  font-style: normal;
  font-weight: 400;
  font-size: 13px !important;
  line-height: 16px;
  font-feature-settings: 'tnum' on, 'lnum' on;
  border: 1px solid ${({ theme }) => theme.colors.divider} !important;
  border-radius: 4px !important;

  background-color: ${({ theme }) => theme.colors.bgPage} !important;
  backdrop-filter: saturate(150%) blur(150px) drop-shadow(4px 4px 10px blue) !important;
  z-index: 4 !important;
  cursor: pointer !important;
`;

// Portal version of SmallTooltip that renders into the body
export const SmallPortalTooltip = React.forwardRef<
  TooltipRefProps,
  React.ComponentProps<typeof UnstyledTooltip>
>((props, ref) => {
  return (
    <TooltipPortal>
      <StyledPortalTooltip {...props} ref={ref} />
    </TooltipPortal>
  );
});

SmallPortalTooltip.displayName = 'SmallPortalTooltip';

// TODO: the tooltip hides when you hover the tooltip
// also, the scrollbar is always visible, even when not needed
// disabled this for now
export const ScrollableTooltip = styled(SmallTooltip)`
  /* overflow: auto !important; */
  max-height: 95vh !important;
  pointer-events: auto !important;
`;
